import "./App.css";
import { createBrowserRouter, Link, RouterProvider } from "react-router-dom";
import Main from "./Layouts/Main";
import home from "./components/Home/Home";
import Home from "./components/Home/Home";
import Orders from "./components/Orders/Orders";
import About from "./components/About/About";
import Grandpa from "./components/Grandpa/Grandpa";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Main></Main>,
      children: [
        {
          path: "/",
          loader: () => fetch("tshirts.json"),
          element: <Home></Home>,
        },
        {
          path: "/orders",
          element: <Orders></Orders>,
        },
        {
          path: "/about",
          element: <About></About>,
        },
        {
          path: "/grandpa",
          element: <Grandpa></Grandpa>,
        },
      ],
    },
  ]);
  return (
    <div className="App">
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
